import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- TESTIMONIAL ---------------------------*
  // *===============================================---*
  {
    path: '/testimonials/list',
    name: 'pages-testimonials-list',
    component: () => import('@/views/pages/testimonial/TestimonialList.vue'),
    meta: {
      action: 'read',
      resource: 'testimonial',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('testimonials.mainVerticalMenu.testimonials'),
    },
  },
  {
    path: '/testimonials/add',
    name: 'pages-testimonials-add',
    component: () => import('@/views/pages/testimonial/TestimonialAdd.vue'),
    meta: {
      resource: 'testimonial',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('testimonials.mainVerticalMenu.testimonials'),
    },
  },
  {
    path: '/testimonials/edit/:id',
    name: 'pages-testimonials-edit',
    component: () => import('@/views/pages/testimonial/TestimonialEdit.vue'),
    meta: {
      resource: 'testimonial',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('testimonials.mainVerticalMenu.testimonials'),
    },
  },
]
